import { createContext, useContext, useState, ReactNode} from 'react';
import { NotificationContextType } from '../../types/NotificationContextType';
const notificationContextInfo = createContext<NotificationContextType>({
  NoteMessage: '',
  setNoteMessage: () => {},
  showMessage: false,
  setShowMessage: () => {},
  statusCode: 0,
  setStatusCode: () => {}
});

interface NotificationProviderProps {
  children: ReactNode;
}


export const NotificationProvider = ({ children} :NotificationProviderProps)=>{
    const [NoteMessage, setNoteMessage] = useState<string>("");
    const [showMessage,setShowMessage] = useState<boolean>(false)
    const[statusCode, setStatusCode] = useState<number>(0)
    return(
        <notificationContextInfo.Provider 
        value={{NoteMessage: NoteMessage, setNoteMessage: setNoteMessage, showMessage: showMessage, setShowMessage: setShowMessage, statusCode: statusCode, setStatusCode: setStatusCode}}
        >
            {children}
        </notificationContextInfo.Provider>
    )
}

export const NotificationConsumer = ()=>{
    return useContext(notificationContextInfo);
}
